/*
 *
 * CommunicationDetailMobile actions
 *
 */

import {
  FLUSH_STATE,
  LOAD_COMMUNICATION,
  LOAD_COMMUNICATION_SUCCESS,
  LOAD_COMMUNICATION_ERROR,
  UPDATE_COMMUNICATION,
  UPDATE_COMMUNICATION_SUCCESS,
  UPDATE_COMMUNICATION_ERROR,
} from './constants';

export function flushState() {
  return {
    type: FLUSH_STATE,
  };
}

/**
 * Load the communication, this action starts the request saga
 *
 * @return {object} An action object with a type of LOAD_COMMUNICATIONS
 */
export function loadCommunication(ID, firstRender = false, urlChildId) {
  return {
    type: LOAD_COMMUNICATION,
    ID,
    firstRender,
    urlChildId,
  };
}

/**
 * Dispatched when the loadCommunication are loaded by the request saga
 *
 * @param  {array} variables true for communication
 *
 * @return {object}      An action object with a type of LOAD_COMMUNICATION_SUCCESS passing the variables
 */
export function loadCommunicationSuccess(itemDetail) {
  return {
    type: LOAD_COMMUNICATION_SUCCESS,
    itemDetail,
  };
}

/**
 * Dispatched when loading the loadCommunication fails
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_COMMUNICATION_ERROR passing the error
 */
export function loadCommunicationError(error) {
  return {
    type: LOAD_COMMUNICATION_ERROR,
    error,
  };
}

// Update for Single User
export function updateCommunication(itemDetail) {
  return {
    type: UPDATE_COMMUNICATION,
    itemDetail,
  };
}
export function updateCommunicationSuccess(itemDetail) {
  return {
    type: UPDATE_COMMUNICATION_SUCCESS,
    itemDetail,
  };
}

export function updateCommunicationError(updateError) {
  return {
    type: UPDATE_COMMUNICATION_ERROR,
    updateError,
  };
}
